import React, { useContext } from 'react';
import styled from 'styled-components';
import { SvgIcon, Grid, Slide, Card } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import {
	breakpoints,
	colours,
	fontSizes,
	H1,
	H2,
	isMobile
} from '@sorted/sorted-ui';
import { useHistory } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
	faPlusCircle,
	// faCheckCircle,
	// faTools,
	faTimes
} from '@fortawesome/pro-regular-svg-icons';
import LandingPageCard from './LandingPageCard';
import MicroFrontendContext from '../../context/MicroFrontendContext';

const CardIcon = withStyles(() => ({
	fontSizeLarge: {
		[`@media (max-width: ${breakpoints.tablet})`]: {
			fontSize: 24
		}
	}
}))(props => {
	return (
		<SvgIcon
			{...props}
			viewBox="0 0 640 512"
			color="primary"
			fontSize="large"
		>
			<path d={props.path} />
		</SvgIcon>
	);
});

const Wrapper = styled.div`
	@media (min-width: ${breakpoints.smallDesktop}) {
		position: relative;
		display: flex;
	}
`;
const FlexContainer = styled.div`
	display: flex;
	flex-direction: row;
	align-items: flex-start;
`;

const GridOuter = styled(Grid)`
	flex: 1;
	padding: 0 0 0 24px;
`;

const GridInner = styled(Grid)`
	position: absolute;
`;

const MobileSlide = styled.div`
	width: 100%;
	height: 100vh;
	position: absolute;
	top: 0;
	left: 0;
	z-index: 1015;
	background-color: ${colours.white};
`;

const H1Styled = styled(H1)`
	margin: 0;
	line-height: 1;
	display: flex;
	justify-items: center;
	padding: 0 20px;
	height: 60px;
	border-bottom: 1px solid ${colours.border};
	align-items: center;
`;

const H2Styled = styled(H2)`
	margin-bottom: 20px;

	@media (min-width: ${breakpoints.smallDesktop}) {
		font-size: ${fontSizes.h2mobile};
		margin-bottom: 12px;
	}
`;

const Span = styled.span`
	margin-left: 10px;

	a {
		color: inherit;
	}
`;

const Div = styled.div`
	padding: 13px 20px;

	background-color: ${({ type }) =>
		(type === 'whatsfixed' && '#fafafa') ||
		(type === 'maintenance' && '#f1f1f1') ||
		colours.white};

	@media (min-width: ${breakpoints.smallDesktop}) {
		color: ${colours.white} !important;

		background-color: ${({ type }) =>
			(type === 'whatsfixed' && '#2a2a2a') ||
			(type === 'maintenance' && '#323232') ||
			'#171717'};
	}
`;
const meterPath =
	'M288 288c-6.04 0-11.77 1.11-17.3 2.67l-75.76-97.4c-8.12-10.45-23.12-12.38-33.69-4.2-10.44 8.12-12.34 23.2-4.19 33.67l75.75 97.39c-5.45 9.42-8.81 20.21-8.81 31.88 0 11.72 3.38 22.55 8.88 32h110.25c5.5-9.45 8.88-20.28 8.88-32C352 316.65 323.35 288 288 288zm0-256C128.94 32 0 160.94 0 320c0 52.8 14.25 102.26 39.06 144.8 5.61 9.62 16.3 15.2 27.44 15.2h443c11.14 0 21.83-5.58 27.44-15.2C561.75 422.26 576 372.8 576 320c0-159.06-128.94-288-288-288zm212.27 400H75.73C57.56 397.63 48 359.12 48 320 48 187.66 155.66 80 288 80s240 107.66 240 240c0 39.12-9.56 77.63-27.73 112z';
const shipmentPath =
	'M492.5 133.4L458.9 32.8C452.4 13.2 434.1 0 413.4 0H98.6c-20.7 0-39 13.2-45.5 32.8L2.5 184.6c-1.6 4.9-2.5 10-2.5 15.2V464c0 26.5 21.5 48 48 48h400c106 0 192-86 192-192 0-90.7-63-166.5-147.5-186.6zM280 48h133.4l26.8 80.4c-49.8 2-94.7 22.7-127.7 55.6H280V48zM98.6 48H232v136H53.3L98.6 48zM48 464V232h229.5c-13.6 26.4-21.5 56.3-21.5 88 0 57.4 25.3 108.8 65.3 144H48zm400 0c-79.4 0-144-64.6-144-144s64.6-144 144-144 144 64.6 144 144-64.6 144-144 144zm64.6-205.7c-3.1-3.1-8.1-3.1-11.2 0l-69.9 69.3-30.3-30.6c-3.1-3.1-8.1-3.1-11.2 0l-18.7 18.6c-3.1 3.1-3.1 8.1 0 11.2l54.4 54.9c3.1 3.1 8.1 3.1 11.2 0l94.2-93.5c3.1-3.1 3.1-8.1 0-11.2l-18.5-18.7z';
const shipmentsGroupPath =
	'M592 224H480V48c0-26.5-21.5-48-48-48H208c-26.5 0-48 21.5-48 48v176H48c-26.5 0-48 21.5-48 48v192c0 26.5 21.5 48 48 48h544c26.5 0 48-21.5 48-48V272c0-26.5-21.5-48-48-48zM208 48h80v72c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V48h80v176H208V48zm88 416H48V272h96v72c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-72h88v192zm296 0H344V272h88v72c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-72h96v192z';

const isMobileView = isMobile();

const ListContainer = ({ toggleOpen }) => {
	return (
		<>
			{isMobileView && (
				<H1Styled>
					Notifications
					<FontAwesomeIcon
						onClick={() => toggleOpen()}
						style={{ marginLeft: 'auto' }}
						color={colours.primary}
						size="sm"
						icon={faTimes}
						fixedWidth
					/>
				</H1Styled>
			)}

			<Div type="whatsnew">
				<H2Styled>What&apos;s new</H2Styled>
				<FlexContainer>
					<FontAwesomeIcon
						size="lg"
						icon={faPlusCircle}
						fixedWidth
						color={colours.green}
					/>

					<Span>
						For the latest news please see{' '}
						<a
							href="https://sorted.com/"
							target="_blank"
							rel="noreferrer"
						>
							Sorted.com
						</a>
					</Span>
				</FlexContainer>
			</Div>

			{/* <Div type="whatsfixed">THINGS1</Div>
			<Div type="maintenance">THINGS2</Div> */}
		</>
	);
};

const WhatsNew = ({ toggleOpen, drawerOpen }) =>
	isMobileView ? (
		<Slide direction="left" in={drawerOpen} mountOnEnter unmountOnExit>
			<MobileSlide>
				<ListContainer toggleOpen={toggleOpen} />
			</MobileSlide>
		</Slide>
	) : (
		<GridOuter container>
			<GridInner item sm={12}>
				<Card elevation={4}>
					<ListContainer toggleOpen={toggleOpen} />
				</Card>
			</GridInner>
		</GridOuter>
	);

const LandingPageCards = ({ toggleOpen, drawerOpen }) => {
	const { user } = useContext(MicroFrontendContext);
	const history = useHistory();

	const cards = [
		{
			title: 'View Shipments',
			subtitle: 'A summary view of all shipments',
			icon: <CardIcon path={meterPath} />,
			onClick: () => history.push('/shipments/dashboard'),
			showForUser: true
		},
		{
			title: 'Create Shipment',
			subtitle: 'Manually create a new shipment',
			button: 'Create',
			icon: <CardIcon path={shipmentPath} />,
			onClick: () => history.push('/shipments/create-shipment'),
			showForUser: user.roles.admin || user.roles.user,
			desktopOnly: true
		},
		{
			title: 'Shipment Groups',
			subtitle: 'A summary of current shipment groups',
			button: 'View',
			icon: <CardIcon path={shipmentsGroupPath} />,
			onClick: () => history.push('/shipments/shipments-groups'),
			showForUser: true
		}
	];

	return (
		<Wrapper>
			<Grid
				container
				spacing={3}
				style={{ width: isMobileView ? '100%' : '75%' }}
			>
				{cards
					.filter(card => card.showForUser)
					.map(card =>
						isMobileView && card.desktopOnly ? null : (
							<Grid key={card.title} item sm={6} md={4}>
								<LandingPageCard {...card} />
							</Grid>
						)
					)}
			</Grid>

			<WhatsNew toggleOpen={toggleOpen} drawerOpen={drawerOpen} />
		</Wrapper>
	);
};

export default LandingPageCards;
